import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import IconButton from "components/elements/IconButton";
import NotificationListing from "./NotificationListing";
import NotificationAdd from "./NotificationAdd";
import NotificationEdit from "./NotificationEdit";
const { default: Header } = require("../../common/Header");

const VIEWS = {
  LISTING: 1,
  ADD: 2,
  EDIT: 3,
};

const Notification = () => {
  const [view, setView] = useState(VIEWS.LISTING);
  const [editNotification, setEditNotification] = useState(null);
  const token = useOutletContext();
  const { name, client_name } = token;

  const edit = x => {
    setEditNotification(x);
    setView(VIEWS.EDIT);
  };

  return (
    <div id="notification" className="page">
      <Header user={name} client_name={client_name} title="Notification" />
      <section>
        {view === VIEWS.LISTING && (
          <NotificationListing submit={() => setView(VIEWS.ADD)} edit={edit} />
        )}
        {view === VIEWS.ADD && (
          <NotificationAdd cancel={() => setView(VIEWS.LISTING)} />
        )}
        {view === VIEWS.EDIT && (
          <NotificationEdit
            notification={editNotification}
            cancel={() => setView(VIEWS.LISTING)}
          />
        )}
      </section>
    </div>
  );
};

export default Notification;
